<template>
    <div>
        <el-alert
            v-if="response && response.status && response.status!=200 && response.status!=400"
            title="Atenção"
            type="error"
            :description="response.msg"
            show-icon
        >
        </el-alert>
    </div>
</template>

<script>

    import Fct from 'common/fct';

    export default {
        name:"ed-error",
        components:{},
        mixins:[],

        props:{

          response:{
            type:Object,
            default:function () { return null }
          },

        },

        data () {
          return {
          }
        },

        mounted() {
        },

        watch:{
            response(){
            },
        },

        methods:{
        }
    }
</script>


<style lang="scss" scoped>

  	body {
	    background: #dedede;
	}
	.page-wrap {
	    min-height: 100vh;
	}
</style>


// WEBPACK FOOTER //
// error.vue?cfc9da0a